import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { headerHeight } from '@/shared/constants';
import { DefaultContainer } from '@/shared/ui';
import LogoLink from './LogoLink';
import MobileMenuDefaultLinks from './MobileMenuDefaultLinks';
import StoreLinks from './StoreLinks';

const MobileMenu = dynamic(() => import('./MobileMenu'));
const DefaultHeader = dynamic(() => import('./DefaultHeader'));
const StoreHeader = dynamic(() => import('./StoreHeader'));

const Header = () => {
  const router = useRouter();

  const showStoreHeader = router.pathname.includes('/store');

  return (
    <DefaultContainer
      alignItems='center'
      containerProps={{
        as: 'header',
        position: 'sticky',
        bg: 'white',
        boxShadow: 'lg',
        zIndex: 'sticky',
        top: 0,
      }}
      flexDir='row'
      gap={{ base: 'md', lg: '4rem' }}
      h={headerHeight}
      justifyContent={{ base: 'space-between', lg: showStoreHeader ? 'space-between' : 'start' }}
      py='0'
    >
      <MobileMenu LinksComponent={showStoreHeader ? StoreLinks : MobileMenuDefaultLinks} />

      <LogoLink
        clickable={false}
        ml={{ base: showStoreHeader ? 0 : '2xl', lg: 0 }}
      />

      {showStoreHeader ? <StoreHeader /> : <DefaultHeader />}
    </DefaultContainer>
  );
};

export default Header;
